import { create } from "zustand";

interface FilterState {
  sourceType: string;
  category: string;
  company: string;
  sentiment: string;
  importantOnly: string;  // "1" = on, "" = off
  riskTransmission: string;  // "1" = on, "" = off
  setFilter: (key: string, value: string) => void;
  resetFilters: () => void;
}

export const useFilterStore = create<FilterState>((set) => ({
  sourceType: "",
  category: "",
  company: "",
  sentiment: "",
  importantOnly: "",
  riskTransmission: "",
  setFilter: (key, value) => set((s) => ({ ...s, [key]: value })),
  resetFilters: () => set({ sourceType: "", category: "", company: "", sentiment: "", importantOnly: "", riskTransmission: "" }),
}));
